<template>
  <div>
    <div class="text-description happyicon" v-if="enoughBalance">
      <IconEmoticonHappyOutline />
    </div>
    <div class="text-description sadicon" v-else>
      <IconEmoticonSadOutline />
    </div>
    <div v-if="loading" class="wrap-btn-payment">
      <b-spinner label="Loading..." variant="'primary'"></b-spinner>
    </div>
    <div v-else class="wrap-btn-payment coins">
      <p v-if="!enoughBalance">{{$t('payment.methods.khaosodCoin.notEnoughCoins')}}</p>
      <p>
        <span class="mif-coins"></span>
        {{$t('payment.methods.khaosodCoin.currentBalance')}} :
        <strong
          :style="{'color': enoughBalance ? 'black' : 'red' }"
        >{{ availableCoins.toLocaleString('th-TH') }}</strong>
      </p>
      <b-button
        v-if="enoughBalance"
        class="btn-payment"
        id="processPayment"
        @click="processPayment"
      >{{ formattedAmount.toLocaleString('th-TH') }}</b-button>
      <b-button
        v-else
        class="btn-payment"
        id="buyCoins"
        @click="buyCoins"
      >{{$t('payment.methods.khaosodCoin.buyCoins')}}</b-button>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapActions } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
import IconEmoticonHappyOutline from "../../icons/IconEmoticonHappyOutline/index";
import IconEmoticonSadOutline from "../../icons/IconEmoticonSadOutline/index";
export default {
  name: "coinsPayment",
  components: {
    IconEmoticonHappyOutline,
    IconEmoticonSadOutline
  },
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    availableCoins: {
      type: Number,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  computed: {
    enoughBalance: function() {
      console.log("this.availableCoins",this.availableCoins)
      console.log("this.amount",this.amount)
      return this.availableCoins >= this.amount;
    }
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    processPayment() {
      this.loading = true;
      var vm = this;
      vm.PAY({
        user_payment_id: vm.orderId
      })
        .then(function(response) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: { id: vm.orderId, previousPendingPaymentId: vm.previousPendingPaymentId }
          });
        })
        .catch(function(error) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: { id: vm.orderId, previousPendingPaymentId: vm.previousPendingPaymentId }
          });
        });
    },
    buyCoins() {
      var vm = this;
      vm.$router.push({
        name: "UserKhaosodCoins",
        params: { displayedComponent: 'UserKhaosodCoins', previousPendingPaymentId: vm.orderId }
      });
    }
  },
  mounted() {
    $(function() {});
  }
};
</script>